import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiGetUserAutoTradeLossCompPool2Records } from "@/api";
import type { GetUserAutoTradeLossCompPool2RecordsResponse } from "@/api/types";
import { getToken } from "@/lib/auth";

const PAGE_SIZE = 20;

export function useGetUserAutoTradeLossCompPool2Records(enabled: boolean) {
  return useInfiniteQuery({
    queryKey: ["userAutoTradeLossCompPool2Records"],
    queryFn: async ({
      pageParam,
    }): Promise<GetUserAutoTradeLossCompPool2RecordsResponse> => {
      const res = await ApiGetUserAutoTradeLossCompPool2Records({
        page: pageParam,
        pageSize: PAGE_SIZE,
      });
      return res.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const fetched = allPages.reduce(
        (sum, page) => sum + (page.records?.length ?? 0),
        0
      );
      if (fetched >= (lastPage.total ?? 0)) return undefined;
      return allPages.length + 1;
    },
    enabled: enabled && !!getToken(),
  });
}
